<div [hidden]="hideElements">
  <app-applicant-header></app-applicant-header>
  <router-outlet></router-outlet>
</div>
